import Vue from 'vue'
import Router from 'vue-router'
import PeticionForm from '@/components/PeticionForm'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'peticionform',
      component: PeticionForm
      // path: '/',
      // name: 'helloworld',
      // component: HelloWorld
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js